var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgIconChevronDown = props => /*#__PURE__*/React.createElement("svg", _extends({
  viewBox: "0 0 18 11",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "m1.722 1.73 7.5 6 7.5-6",
  fill: "none",
  stroke: "currentColor",
  strokeWidth: 4
})));
export { SvgIconChevronDown as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB2aWV3Qm94PSIwIDAgMTggMTEiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PHBhdGggZD0ibTI2OS43MjE4MjUgMTk1LjczMDE0MSA3LjUgNiA3LjUtNiIgZmlsbD0ibm9uZSIgc3Ryb2tlPSJjdXJyZW50Q29sb3IiIHN0cm9rZS13aWR0aD0iNCIgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoLTI2OCAtMTk0KSIvPjwvc3ZnPgo=";